import React from "react";
import { Row, Col, Modal } from "react-bootstrap";
import image from "../../images/mit-redgrey-footer3.gif";
import Feedback from "./Feedback";

interface FooterStates
{
    show: boolean;
}

class Footer extends React.Component<any, FooterStates>
{
    constructor(props: any)
    {
        super(props);
        this.state = {
            show: false
        };
    }

    render(): React.ReactNode
    {
        return <Row id="footer" className="no-padding-top">
            <Col lg={8} id="footerLeft">
                <a className={"float-left"} href="http://web.mit.edu">
                    <img src={image} height="28" alt="Massachusetts Institute of Technology" title="Massachusetts Institute of Technology" /> Massachusetts Institute of Technology
                </a>
            </Col>
            <Col lg={4} id="footerRight" className="textAlignRight">
                <Feedback footer={true} />
                <a onClick={() => this.setState({ show: true })}>Accessibility</a>
            </Col>
            <Modal centered show={this.state.show} onHide={() => this.setState({ show: false })}>
                <Modal.Header closeButton>
                    <Modal.Title>Accessibility</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={"m-3"}>
                        <p>MIT IST is committed to providing an environment that is accessible to individuals with disabilities. If you cannot access content or use features on our website due to a disability, please let us know. Use the feeback form to contact the help team</p>
                    </div>
                </Modal.Body>
            </Modal>
        </Row>;
    }
}

export default Footer;